import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { toast } from "sonner";
import { Check, X, Trash2 } from "lucide-react";
import { formatDate } from "../../lib/format";

export default function CommentsAdmin() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => {
    const params = {};
    if (filter !== "all") params.approved = filter === "approved";
    api.get("/comments", { params }).then(r => setItems(r.data || []));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const moderate = async (id, ok) => {
    await api.patch(`/comments/${id}?approved=${ok}`);
    toast.success(ok ? "Aprovado" : "Reprovado"); load();
  };
  const remove = async (id) => { if (!window.confirm("Excluir?")) return; await api.delete(`/comments/${id}`); load(); };

  return (
    <AdminLayout>
      <div data-testid="admin-comments">
        <h1 className="font-serif-display text-4xl font-bold">Comentários</h1>
        <div className="flex gap-2 mt-4">
          {[{k:"all",l:"Todos"},{k:"approved",l:"Aprovados"},{k:"pending",l:"Pendentes"}].map(t => (
            <button key={t.k} onClick={() => setFilter(t.k)} className={`px-3 py-1.5 font-sans-ui text-xs uppercase border ${filter===t.k?"bg-black text-white border-black":"bg-white border-zinc-300"}`}>{t.l}</button>
          ))}
        </div>
        <div className="mt-6 space-y-3">
          {items.map(c => (
            <div key={c.id} className="border border-zinc-300 bg-white p-4" data-testid={`comment-row-${c.id}`}>
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-sans-ui font-semibold">{c.name} <span className="text-zinc-500 text-xs font-normal">· {c.email}</span></p>
                  <p className="font-sans-ui text-xs text-zinc-500">{formatDate(c.created_at)} · {c.approved ? "Aprovado" : "Pendente"}</p>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => moderate(c.id, !c.approved)} className="p-1.5 border border-zinc-300">{c.approved ? <X size={14}/> : <Check size={14}/>}</button>
                  <button onClick={() => remove(c.id)} className="p-1.5 border border-zinc-300 text-red-700"><Trash2 size={14}/></button>
                </div>
              </div>
              <p className="font-body mt-2">{c.content}</p>
            </div>
          ))}
          {items.length === 0 && <p className="text-center text-zinc-500 font-sans-ui p-6 border border-zinc-300 bg-white">Nenhum comentário.</p>}
        </div>
      </div>
    </AdminLayout>
  );
}
